import useWindowsSize from "@/Hooks/useWindowsSize";

interface Props {
  ancho: number;
  alto: number;
}

export const FiguraSvg = ({ ancho, alto }: Props) => {
  const { width } = useWindowsSize();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.0"
      width={ancho} //1602
      height={alto} //1073
      viewBox={width < 1200 ? "0 0 1602 1073" : "0 0 1500 200"} //"0 0 1602 1073"
      className={
        width > 700
          ? "svg-background position-absolute"
          : "svg-background position-absolute svg-backgroundds"
      }
      preserveAspectRatio="xMidYMid meet">
      <g
        transform="translate(0.000000,1073.000000) scale(0.100000,-0.100000)"
        fill="#d52b1e"
        stroke="none">
        <path d="M15930 10632 c-47 -42 -167 -149 -265 -237 -99 -88 -310 -277 -470 -420 -673 -605 -1196 -1059 -1585 -1376 -1032 -840 -1903 -1394 -2800 -1779 -113 -48 -225 -95 -250 -103 -25 -8 -93 -34 -153 -56 -59 -23 -160 -57 -225 -77 -64 -20 -153 -47 -197 -61 -172 -54 -424 -115 -650 -158 -77 -14 -149 -28 -160 -30 -83 -16 -393 -56 -585 -75 -413 -40 -1112 -40 -1623 0 -288 22 -784 80 -1032 120 -33 5 -132 21 -220 35 -210 33 -255 41 -410 70 -71 14 -227 43 -345 65 -118 22 -233 45 -255 50 -22 5 -76 16 -120 25 -44 9 -98 20 -120 25 -22 5 -148 32 -280 60 -242 51 -320 69 -497 110 -60 14 -840 189 -913 205 -33 7 -211 47 -395 90 -283 64 -929 207 -1065 235 -22 4 -92 19 -156 33 -181 40 -946 191 -1121 221 l-38 7 0 -3806 0 -3805 8010 0 8010 0 0 5355 c0 2945 -1 5355 -2 5354 -2 0 -41 -35 -88 -77z" />
      </g>
    </svg>
  );
};
